module.exports = function stripTags(text){
    return text.replace(/(<([^>]+)>)/gi, "");
}